import React from 'react';

const ClickKill =()=>{
    return(
        <h1>Hello!</h1>
    )
}
export default ClickKill